<template>
    <div class="candidat">
        <div v-if="session.application_session!=null">
            <div class="font-bold text-xl text-red mb-3" v-if="session.application_session.first_step_status=='1' && (visible_add_candidate == true)" >Vous pouvez déposer votre candidature pour la session actuelle.</div>
            <div class="font-bold text-md text-blue mb-3" v-if="session.application_session.first_step_status=='1' && (visible_add_candidate == true)" v-html="this.session.application_session.comment">
            </div>

            <!-- <div class="font-bold text-md text-blue mb-3">
              Veuillez noter que pour cette session on acceptera {{this.session.application_session.max_label_applications}} candidatures pour le Label.<br>
              La date limite de soumission des candidatures est le {{new Date(session.application_session.first_step_end_date)| dateFormat('DD/MM/YYYY')}}.
            </div>-->
            <div>
            </div>
        </div>
        <div v-if="session.application_session && session.application_session.first_step_status!='1' ">
            <div class="font-bold text-xl text-red mb-3">{{ $t("candidat.no_session_send") }}</div>
            <div class="font-bold text-md text-blue mb-3">{{ $t("candidat.can_send_candidat") }}</div>
        </div>
        <Candidat v-if="session.application_session && visible_add_candidate == true" :edit_app="true"></Candidat>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_ApplicationMenuActive} from "@/store/mutations.type";
    import Candidat from "@/components/Candidat/candidat.vue";

    export default {
        name: "candidat",
        components: {
            "Candidat": Candidat
        },
        data() {
            return {
                visible_add_candidate: false,
            };
        },
        mounted() {
            this.visible_add_candidate = true;
            this.$store.commit(SET_ApplicationMenuActive, 1);
        },

        computed: {
            ...mapGetters(["session","ApplicationMenuActive"])
        }
    };
</script>
